import React from 'react';

type AlertSeverity = 'critical' | 'warning' | 'info';

interface Alert {
  id: string | number;
  severity: AlertSeverity;
  category: string;
  created_at: string;
  title: string;
  message: string;
}

interface AlertsPanelProps {
  alerts?: Alert[];
}

const AlertsPanel: React.FC<AlertsPanelProps> = ({ alerts = [] }) => {
  if (!alerts || alerts.length === 0) {
    return (
      <div className="alerts-panel">
        <h3>🔔 Alerts</h3>
        <div className="no-alerts">
          <span>✅ No active alerts</span>
        </div>
      </div>
    );
  }

  const getSeverityIcon = (severity: AlertSeverity) => {
    switch (severity) {
      case 'critical': return '🚨';
      case 'warning': return '⚠️';
      case 'info': return 'ℹ️';
      default: return '📢';
    }
  };

  const getSeverityColor = (severity: AlertSeverity) => {
    switch (severity) {
      case 'critical': return 'red';
      case 'warning': return 'yellow';
      case 'info': return 'blue';
      default: return 'gray';
    }
  };

  return (
    <div className="alerts-panel">
      <h3>🔔 Active Alerts ({alerts.length})</h3>
      <div className="alerts-list">
        {alerts.map((alert, index) => (
          <div key={index} className={`alert-item ${getSeverityColor(alert.severity)}`}>
            <div className="alert-header">
              <span className="alert-icon">
                {getSeverityIcon(alert.severity)}
              </span>
              <span className="alert-category">{alert.category}</span>
              <span className="alert-time">
                {new Date(alert.created_at).toLocaleTimeString()}
              </span>
            </div>
            <div className="alert-title">{alert.title}</div>
            <div className="alert-message">{alert.message}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AlertsPanel; 